export const DEFAULT_ARIA_LABEL = 'Copy to clipboard' as const
export const DEFAULT_COPIED_ARIA_LABEL = 'Copied to clipboard' as const
export const DEFAULT_COPIED_TOOLTIP_LABEL = 'Copied' as const
export const DEFAULT_RESET_TIMEOUT = 2000 as const
export const DEFAULT_TOOLTIP_LABEL = 'Copy' as const
